import { createApp, } from 'vue';
import { setupDirectives, } from '@/directives';
// import '@/utils/rem';

import 'ress/ress.css';
import '@/assets/styles/common.scss';
import '@/assets/styles/responsive.scss';
import HoroUI, { useFontFamily, useDesignToken, } from '@nio-fe/horo-h5';
import { HIconFont as HIconFontNio, } from '@nio-fe/horo-icons';
import { HIconFont as HIconFontFy, } from '@nio-fe/horo-icons-fy';
import { HIconFont as HIconFontAlps, } from '@nio-fe/horo-icons-alps';
import HoroBridge from '@nio-fe/horo-bridge';
import { setupStore, } from '@/store';
import { setupRouter, } from '@/router';
import { setupTracker, setupAPM, } from '@/monitor';

import App from './App.vue';
import 'animate.css';

/**
 * 根据url中query中的brand参数判断是否需要引入css token 文件
 */
const app = createApp(App);

if (process.env.BRAND === 'nio') {
  import('@/assets/styles/responsive.nio.scss');
  import('@nio-fe/horo-h5/dist/style.css');
  useDesignToken('sk');
  useFontFamily('cn', 'nio');
  app.component('HIconFont', HIconFontNio);
  import('@nio-fe/horo-icons/lib/style.css');
}
if (process.env.BRAND === 'alps') {
  import('@nio-fe/horo-h5/dist/style.alps.css');
  useDesignToken('alps');
  useFontFamily('cn', 'alps');
  app.component('HIconFont', HIconFontAlps);
  import('@nio-fe/horo-icons-alps/lib/style.css'); // sk 字体样式，svg 无需引用
}
if (process.env.BRAND === 'fy') {
  import('@nio-fe/horo-h5/dist/style.fy.css');
  useDesignToken('fy');
  useFontFamily('cn', 'fy');
  app.component('HIconFont', HIconFontFy);
  import('@nio-fe/horo-icons-fy/lib/style.css'); // sk 字体样式，svg 无需引用
}

app.use(HoroUI);
app.use(HoroBridge, {
  components: {
    safeArea: true,
    button: true,
  },
});

// 配置store
setupStore(app);

// 配置路由
setupRouter(app);

// 配置指令
setupDirectives(app);

// 配置监控
setupAPM(app);

// 配置埋点
setupTracker();

app.mount('#app');
